export enum FieldTypeEnum {
    button = 'button',
    checkbox = 'checkbox',
    date = 'date',
    datetime = 'datetime',
    icon = 'icon',
    image = 'image',
    number = 'number',
    option = 'option',
    select = 'select',
    text = 'text',
    textarea = 'textarea',
    time = 'time',
    slidetoggle = 'slidetoggle',
    label = 'label',
    filterSelect = 'filterSelect',
    fileSelect = 'fileSelect',
    chips = 'chips',
    chipsMultiSelect = 'chipsMultiSelect',
    multiOption = 'multiOption',
    custom = 'custom',
    divider = 'divider',
    buttonToggle = 'buttonToggle',
    signature = 'signature'
}

export enum MultipleOptionType {
    slideToggle = 'slideToggle',
    checkBox = 'checkBox'
}
